import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PagamentoInteligenteComponent } from './pagamento-inteligente.component';
import { SimulacaoVendaComponent } from './simulacao-venda/simulacao-venda.component';
import { ListaSimulacaoComponent } from './lista-simulacao/lista-simulacao.component';
import { AuthGuardService } from '../../shared/filters/auth-guard.service';
import { SimulacaoVendaWebtefComponent } from './simulacao-venda-webtef/simulacao-venda-webtef.component';
import { HistoricoVendasComponent } from './historico-vendas/historico-vendas.component';

const routes: Routes = [{
  path: '',
  component: PagamentoInteligenteComponent,
  children: [
    {
      path: 'simulacao-venda',
      component: SimulacaoVendaComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['SIMULACAO_DE_VENDA'] }
    },
    {
      path: 'simulacao-venda-webtef',
      component: SimulacaoVendaWebtefComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['SIMULACAO_DE_VENDA_WEBTEF'] }
    },
    {
      path: 'lista-simulacao',
      component: ListaSimulacaoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['LISTA_SIMULACAO'] }
    },
    {
      path: 'historico-venda',
      component: HistoricoVendasComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['HISTORICO_VENDA'] }
    },

  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
})
export class PagamentoInteligenteRoutingModule { }


export const routedComponents = [
 PagamentoInteligenteComponent,
 SimulacaoVendaComponent,
 ListaSimulacaoComponent,
];
